export const config = {
  isMainnet: true,
  devNetRpcUrl: "https://api.devnet.solana.com/",
  mainNetRpcUrl: "https://rpc.shyft.to?api_key=BAO4x3_kGu4ktdxx",
};